import React from 'react';
import { ColorPickerDropdown } from './ColorPickerDropdown';
import { LicenseDropdown } from './LicenseDropdown';
import { EmployeeSearchSelect } from './EmployeeSearchSelect';
import { GenericSearchSelect } from './GenericSearchSelect';
import '../../../../components/shared/forms.css';

/**
 * EmployeeCardEdit Component - Form for adding or editing an employee.
 */
export function EmployeeCardEdit({
    data,
    onChange,
    onSave,
    onCancel,
    onDelete,
    categories,
    employees,
    licenseOptions,
    attemptedSave
}) {
    const update = (field, value) => onChange({ ...data, [field]: value });

    const roleOptions = categories.map(c => ({ value: c.id, label: c.name }));
    const replacementOptions = employees
        .filter(e => String(e.id) !== String(data.id))
        .map(e => ({ value: e.id, label: e.name }));

    return (
        <div className="employee-card editing" onClick={e => e.stopPropagation()}>
            <div className="employee-edit-title">
                <span>👤</span> Mitarbeiter Details
            </div>

            <div className="employee-edit-grid">
                <div className="employee-edit-row">
                    <div className="form-group flex-3">
                        <span className="form-label">Name *</span>
                        <input
                            className={`form-input ${attemptedSave && !data.name?.trim() ? 'form-field-error' : ''}`}
                            value={data.name || ''}
                            onChange={e => update('name', e.target.value)}
                            placeholder="Max Mustermann"
                            autoFocus
                        />
                        {attemptedSave && !data.name?.trim() && (
                            <div className="form-error-message">Bitte Name eingeben</div>
                        )}
                    </div>

                    <div className="form-group flex-1">
                        <span className="form-label">Farbe</span>
                        <ColorPickerDropdown
                            value={data.color}
                            onChange={(color) => update('color', color)}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <span className="form-label">Rolle</span>
                    <GenericSearchSelect 
                        value={data.employee_category_id}
                        options={roleOptions}
                        onChange={(val) => update('employee_category_id', val)}
                        placeholder="Rolle wählen..."
                        emptyLabel="— Keine Rolle —"
                    />
                </div>

                <div className="form-group">
                    <span className="form-label">Urlaubsvertretung</span>
                    <GenericSearchSelect 
                        value={data.vacation_replacement_id}
                        options={replacementOptions}
                        onChange={(val) => update('vacation_replacement_id', val)}
                        placeholder="Vertretung wählen..."
                        emptyLabel="— Keine —"
                    />
                </div>

                <div className="form-group">
                    <span className="form-label">E-Mail</span>
                    <input
                        className="form-input"
                        type="email"
                        value={data.email || ''}
                        onChange={e => update('email', e.target.value)}
                        placeholder="email@beispiel.de"
                    />
                </div>

                <div className="form-group">
                    <span className="form-label">Telefon</span>
                    <input
                        className="form-input"
                        value={data.phone || ''}
                        onChange={e => update('phone', e.target.value)}
                        placeholder="+49..."
                    />
                </div>

                <div className="employee-edit-section-title full-width">
                    <span>🚨</span> Notfallkontakt
                </div>

                <div className="form-group">
                    <span className="form-label">Name</span>
                    <EmployeeSearchSelect
                        value={data.emergency_contact_name}
                        employees={employees}
                        dataId={data.id}
                        placeholder="Kollegen wählen oder Tippen"
                        onChange={(name, phone) => {
                            if (phone) {
                                onChange({
                                    ...data,
                                    emergency_contact_name: name,
                                    emergency_contact_phone: phone
                                });
                            } else {
                                update('emergency_contact_name', name);
                            }
                        }}
                    />
                </div>

                <div className="form-group">
                    <span className="form-label">Telefon</span>
                    <input
                        className="form-input"
                        value={data.emergency_contact_phone || ''}
                        onChange={e => update('emergency_contact_phone', e.target.value)}
                        placeholder="Notfall-Nummer"
                    />
                </div>

                <div className="form-group full-width">
                    <span className="form-label">Führerscheinklassen</span>
                    <LicenseDropdown
                        selected={data.license_categories}
                        options={licenseOptions}
                        onChange={(lics) => update('license_categories', lics)}
                    />
                </div>
            </div>

            <div className="employee-edit-actions-row">
                <div className="validation-legend">
                    <span style={{ color: '#ef4444', fontWeight: 'bold' }}>*</span> Pflichtfeld
                </div>
                
                <div className="employee-edit-actions">
                    {!data.isNew && (
                        <button className="employee-edit-delete-btn" onClick={() => onDelete(data.id)}>
                            🗑️ Löschen
                        </button>
                    )}
                    <button className="employee-edit-save-btn" onClick={onSave}>
                        {data.isNew ? 'Hinzufügen' : 'Speichern'}
                    </button>
                    <button className="employee-edit-cancel-btn" onClick={onCancel}>Abbrechen</button>
                </div>
            </div>
        </div>
    );
}
